import { setAuthState } from './auth';
import { update as updateProfile } from '../api/profile';

// Persist a tutorial option locally first (so a gate on it closes immediately, even before the request
// resolves) then best-effort sync to the backend. The value can change: the AutoApply Queue new user
// tutorial records the application it follows, so a key that is already set is written again.
// The key has to be listed in User::CLIENT_WRITABLE_OPTIONS, or the backend drops it.
export const persistTutorialOption = async (key, value) => {
	const { getUser, setUser } = setAuthState();
	const user = getUser();

	if (! user) {
		return;
	}

	setUser({ ...user, options: { ...user.options, [key]: value } });

	try {
		await updateProfile({ options: { [key]: value } });
	} catch {
		// The local value is already set; a failed sync just means it may be lost after a reload.
	}
};

// Persist a tutorial flag the same way, guarded against the double fire that finishing a tour two
// ways emits: intro.js's oncomplete + onexit, or the review tour's finish + onBeforeUnmount.
// Shared by the AutoApply intro coachmark, the Application Review tour (use-review-tour.js) and the
// AutoApply Queue tour (autoapply-queue-tutorial.store.js). It lives apart from auto-apply-tutorial.js
// so the queue tour can use it without importing the AutoApply store back into the queue store.
export const persistTutorialFlag = async (flag) => {
	const { getUser } = setAuthState();

	if (getUser()?.options?.[flag]) {
		return;
	}

	await persistTutorialOption(flag, true);
};
